export default __webpack_public_path__ + "static/media/Email.1fdb6995.svg";